const severityRank = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
  CRITICAL: 4,
};

export const sortBySeverityAndConfidence = (items = []) => {
  return [...items].sort((a, b) => {
    const sevDiff = (severityRank[b?.severity] || 0) - (severityRank[a?.severity] || 0);
    if (sevDiff !== 0) return sevDiff;
    return Number(b?.confidence || 0) - Number(a?.confidence || 0);
  });
};

export const formatConfidencePercent = (value) => `${Math.round(Number(value || 0) * 100)}%`;

export const formatScopeLabel = (scopeType, scopeKey) => {
  if (!scopeType) return '-';
  return `${String(scopeType).toUpperCase()} � ${scopeKey || '-'}`;
};
